import { useEffect } from 'react';
import { mergeAttributes, Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import styles from './EditorExtension_AlbumLink.module.css';
//import { useCCContext } from '../CC/CCContext';
//import { CC } from '../CC/CC';
//import * as ccUtils from '../CC/utils';
//import { generateQuery, postWithCache } from '../CC/utils';
/*
const cssStringToObject = (cssString) => {
  return cssString.split(';').reduce((acc, style) => {
    if (style.trim()) {
      let [property, value] = style.split(':').map(str => str.trim());

      // Convert kebab-case to camelCase
      property = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());

      // Handle numeric values
      if (!isNaN(value) && value.trim() !== '') {
        value = Number(value);
      }

      acc[property] = value;
    }
    return acc;
  }, {});
};
*/
export default Node.create({
  name: 'reactComponentAlbumLink',
  group: 'inline',
  //content: 'block*', //added
  inline: true,
  atom: true,
  addAttributes() {
    return {
      selected: {
        default: false,
        parseHTML: (element) => element.getAttribute('data-selected') === 'true',
        renderHTML: (attributes) => ({
          'data-selected': attributes.selected
        }),
      },
      state: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-state'),
        renderHTML: (attributes) => ({
          'data-state': attributes.state
        }),
      },
      query: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-query'),
        renderHTML: (attributes) => ({
          'data-query': attributes.query
        }),
      },
      htmlStyle: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-html-style'),
        renderHTML: (attributes) => ({
          'data-html-style': attributes.htmlStyle
        }),
      },
      linkText: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-link-text'),
        renderHTML: (attributes) => ({
          'data-link-text': attributes.linkText
        }),
      },
      linkAlbumId: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-link-album-id'),
        renderHTML: (attributes) => ({
          'data-link-album-id': attributes.linkAlbumId
        }),
      },
      compClass: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-class'),
        renderHTML: (attributes) => ({
          'data-class': attributes.compClass
        }),
      },
    }
  },
  parseHTML() {
    return [{ tag: 'AlbumLink' }]
  },
  renderHTML({ HTMLAttributes }) {
    return ['AlbumLink', mergeAttributes(HTMLAttributes)];
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});

const Component = (props) => {
  //const ctx = useCCContext();
  //const { cc, setCc, first, setFirst, setSelectedRecord, clearSearch } = ctx;
  const { selected, updateAttributes } = props;
  const { htmlStyle, linkText, linkAlbumId, compClass } = props.node.attrs;
  //const componentRef = useRef({});

  useEffect(() => {
    const handleSelection = () => {
      updateAttributes({ selected: props.editor.isActive('reactComponentAlbumLink') });
    };
    props.editor.on('selectionUpdate', handleSelection);
    return () => {
      props.editor.off('selectionUpdate', handleSelection);
    };
  }, [props.editor, updateAttributes]);

  const handleClick = (event) => {
    if (!props.editor.isEditable) {
      event.preventDefault();
      const customEvent = new CustomEvent('albumLinkClick', {
        detail: {
          albumId: linkAlbumId,
        },
        bubbles: true,
        cancelable: true,
      });
      event.target.dispatchEvent(customEvent);
    }
  };

  const handleDoubleClick = (event) => {
    if (props.editor.isEditable) {
      event.stopPropagation();
      const { state, query, htmlStyle, linkText, linkAlbumId, compClass } = props.node.attrs;
      const customEvent = new CustomEvent('showInsertContentPopup', {
        detail: {
          extension: 'AlbumLink',
          props: { state, query, htmlStyle, linkText, linkAlbumId, compClass },
          pos: props.getPos(),
          node: props.node
        },
        bubbles: true,
        cancelable: true
      });
      event.target.dispatchEvent(customEvent);
    }
  };

  //console.log(htmlStyle);
  //console.log(JSON.stringify(cssStringToObject(htmlStyle)));

  return (
    <NodeViewWrapper as="span" className={`react-component ${selected ? 'selected' : ''}`}>
      <span
        className={styles.hyperlink}
        onClick={handleClick}
        onDoubleClick={handleDoubleClick}
        dangerouslySetInnerHTML={{
          __html: `<span style="${htmlStyle}" class="${compClass}">${linkText}</span>`
        }}
      />
    </NodeViewWrapper>
  );
};
